export class ClienteAnaliseMercadoOptions {
    canOpenCliente: boolean;
    canOpenAnaliseMercado: boolean;
    canDeleteLancamentoClassificacao: boolean;
    canInsertCentralCompra: boolean;
    canEditCentralCompra: boolean;
    canInsertParticipanteCentralCompra: boolean;
    canPreBaixarCliente: boolean;
    canBaixarCliente: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.hasOptionsAnalise() ||
                this.hasOptionsCliente() ||
                this.hasOptionsCentralCompra();
    }

    /** Verifica se possui alguma opção referente a análise habilitada */
    hasOptionsAnalise(): boolean {
        return this.canOpenAnaliseMercado ||
                this.canDeleteLancamentoClassificacao;
    }

    /** Verifica se possui alguma opção referente ao cliente  habilitada */
    hasOptionsCliente(): boolean {
        return this.canOpenCliente ||
                this.canPreBaixarCliente ||
                this.canBaixarCliente;
    }

    /** Verifica se possui alguma opção referente a central de compras habilitada */
    hasOptionsCentralCompra() {
        return this.canInsertCentralCompra ||
                this.canEditCentralCompra ||
                this.canInsertParticipanteCentralCompra;
    }
}
